import { isNullOrEmptyString } from './object-utils';

export const parseNumber = (value) => {
	if (typeof (value) === "number")
		return value;

	if (isNullOrEmptyString(value))
		return null;

	let parsed = Number(value);
	if (isNaN(parsed))
		return null;

	return parsed;
};